import { render, staticRenderFns } from "./Environment.vue?vue&type=template&id=5453ee1c"
import script from "./Environment.vue?vue&type=script&lang=js"
export * from "./Environment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5453ee1c')) {
      api.createRecord('5453ee1c', component.options)
    } else {
      api.reload('5453ee1c', component.options)
    }
    module.hot.accept("./Environment.vue?vue&type=template&id=5453ee1c", function () {
      api.rerender('5453ee1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/select/Environment.vue"
export default component.exports